import React from "react";
import styled from "styled-components";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const BookSchedule = ()=> {
    return (
        <>
        Imo mama, report.

        </>
    );
};

export default BookSchedule;